import {
  CustomGetMyTasksQuery,
  CustomGetMyTasksQueryVariables,
  useCustomGetMyTasksQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetMyTasks(variables: CustomGetMyTasksQueryVariables) {
  const { userId, all, ...rest } = variables;
  const { data: graphqlData, loading, error, fetchMore, refetch } = useCustomGetMyTasksQuery({
    variables: {
      ...rest,
      ...(userId ? { userId } : {}),
      ...(all ? { all: true } : {}),
    },
    fetchPolicy: "network-only",
  });

  const getData = useCallback(({ data }: { data?: CustomGetMyTasksQuery }) => {
    return data?.getMyTasks?.data || null;
  }, []);

  const getPaginatorInfo = useCallback(({ data }: { data?: CustomGetMyTasksQuery }) => {
    return data?.getMyTasks?.paginatorInfo || null;
  }, []);

  const data = useMemo(() => getData({ data: graphqlData }), [graphqlData, getData]);
  const paginatorInfo = useMemo(
    () => getPaginatorInfo({ data: graphqlData }),
    [graphqlData, getPaginatorInfo]
  );

  return { data, loading, error, paginatorInfo, fetchMore, refetch, getData, getPaginatorInfo } as const;
}
